import React, { Suspense } from "react";
import { Route, RouteProps, Switch } from "react-router";
import { BrowserRouter as Router } from "react-router-dom";
import Homepage from "../containers/Home";
// import { FillLoader } from '../components'
// import SideBar from '../components/SideBar'
// import PageNotFound from '../containers/PageNotFound'
// import { useAuthContext } from '../context/AuthProvider'
import { PUBLIC_ROUTES } from "./routes";

interface RouteType extends RouteProps {
  component: any;
}
export type NavItem = {
  to: string;
  title: string;
  icon: React.ReactNode;
  subMenu?: Array<{ to: string; title: string }>;
};

const PublicRoute = ({ component: Component, ...rest }: RouteType) => (
  <Route {...rest}>
    <Component />
  </Route>
);
const Navigation = (): JSX.Element => (
  <Router>
    <Suspense fallback={<Homepage />}>
      <Switch>
        {PUBLIC_ROUTES.map((route) => {
          return <PublicRoute key={route.path} {...route} />;
        })}
        {/* <Route
            path="/auth"
            render={() => (
              <SideBar
                bg="gray.900"
                color="white"
                navItems={NAV_ITEMS}
                hoverColor="gray.700"
                accentColor="cyan.500"
              >
                {PRIVATE_ROUTES.map((route) => {
                  return <PrivateRoute key={route.path} {...route} />
                })}
              </SideBar>
            )}
          /> */}
        {/* <Route render={PageNotFound} /> */}
      </Switch>
    </Suspense>
  </Router>
);

export default Navigation;
